export default "__VITE_PUBLIC_ASSET__65aa0d67__"